import styled, { CSSProperties } from 'styled-components'
import { ReactNode } from 'react'

const MessageCard = styled.div`
  display: flex;
  align-items: center;
  filter: drop-shadow(1px 1px 0 ${({ theme }) => theme.colors.border.primary});
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.card.background};
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.card.hover};
    border-color: ${({ theme }) => theme.colors.border.primary};
  }
`

interface Props {
  children: ReactNode
  style?: CSSProperties
  className?: string
  onClick?: () => void
}

const RaisedButton = ({ children, style, className, onClick }: Props) => (
  <MessageCard style={style} className={className} onClick={onClick}>
    {children}
  </MessageCard>
)

export default RaisedButton
